import { defineStore } from 'pinia'

export const useProductDetailsStore = defineStore('productDetails', () => {
  const { API_ENDPOINTS } = useApiEndpoints()

  // state
  const productDetails = ref(null)

  // actions
  const setProductImages = (images) => {
    if (productDetails.value) {
      productDetails.value.product_images = images
    }
  }

  const fetchProductDetails = async (productUrl) => {
    if (!productUrl) return

    const response = await useBaseOFetchWithAuth(
      API_ENDPOINTS.public.products.details(productUrl)
    )
    productDetails.value = response.data
  }

  // getters
  const getProductDetails = computed(() => productDetails.value)

  return {
    // state
    productDetails,
    // actions
    fetchProductDetails,
    setProductImages,
    // getters
    getProductDetails
  }
})
